export default {
  data: function data() {
    return {
      tabFocused: false
    };
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/vuetify/es5/mixins/tab-focusable.js
// module id = null
// module chunks = 